import { NavLink } from 'react-router-dom';
import type { ReactNode } from 'react';

export function NavItem({ to, icon, children }: { to: string; icon: string; children: ReactNode }) {
  return (
    <NavLink to={to} className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
      <i className={`ti ${icon} nav-icon`} />
      {children}
    </NavLink>
  );
}

export function NavItemDisabled({ icon, children }: { icon: string; children: ReactNode }) {
  return (
    <span className="nav-item nav-item-disabled" title="Em breve">
      <i className={`ti ${icon} nav-icon`} />
      {children}
    </span>
  );
}
